/* istanbul ignore file */
export const WIDGET_META_TYPE = 'meta';
